export const formatNumberWithLimit = number => {
  const value = parseFloat(number);
  if (isNaN(value)) return 0;
  return value < 1000 ? value : value.toLocaleString('en-US');
};
